window.gred = window.gred || {};
gred.init = function () {
  gred.updateP();
  gred.showPopup();
  gred.hidePopup();
  gred.btnAddtocart();
  gred.removeItemsInMiniCart();
  gred.quantity();


};


jQuery(document).ready(function(){
  "use strict";

  $('.x-offcanvas').on('click', function(e) {
    e.preventDefault();
    $('.backdrop').toggleClass('active');
    $('.offcanvas-cart').toggleClass('active');
    $('body').toggleClass('ov-h');

    setTimeout(function(){
      $('.Drawer--right').toggleClass('active');
    },500);

    return false;
  })

  $('.site-header__link.site-header__cart').on('click', function(e) {
    e.preventDefault();
    $('.Drawer--right').addClass('active');
    $('.offcanvas-cart').addClass('active');
    $('.backdrop').addClass('active');
    $('body').addClass('ov-h');

    return false;
  })

  $('.backdrop').on('click', function(e) {
    e.preventDefault();
    $('.backdrop').toggleClass('active');
    $('.offcanvas-cart').toggleClass('active');
    $('body').toggleClass('ov-h');

    setTimeout(function(){
      $('.Drawer--right').toggleClass('active');
    },500);

    return false;
  })

})

/* REMOVE ITEM CART */
gred.removeItemsInMiniCart = function() {
  $(document).on('click', '.btn-remove', function(event) {

    event.preventDefault();
    var productId = $(this).closest('.item').attr('id');
    var item = $(this).closest('.item');
    $(this).closest('.item').fadeOut("slow", () => { $(this).closest('.item').remove(); });

    productId = productId.match(/\d+/g);

    Shopify.removeItem(productId, function(cart) {
      gred.updateMiniCart(cart);
    });
	return false;
  });
};

/********************************************************
# SHOW POPUP
********************************************************/
gred.showPopup = function (selector) {
  $(selector).addClass('active');
};

/********************************************************
# HIDE POPUP
********************************************************/
gred.hidePopup = function (selector) {
  $(selector).removeClass('active');
}


/********************************************************
# Plus - Mins
********************************************************/
gred.quantity = function () {
  $('.x-qty').click(function(e){
    var currentVal = $(this).parent().find('.xx-qty').html();
    currentVal = parseInt(currentVal);
    var fieldName = $(this).attr('data-v');
    if(fieldName == 'minus'){
      currentVal = currentVal - 1;
    }else{
      currentVal = currentVal + 1;
    }

    if(currentVal >= 0){
      $(this).parent().find('.xx-qty').html(currentVal);
    }

    if(currentVal == 0){
      $(this).closest('.cart__row').fadeOut(300, function() { $(this).remove(); });
      $(this).closest('li.item').fadeOut(300, function() { $(this).remove(); });
    }

    var quantity = currentVal;
    var variant_id = $(this).parent().find('.xx-qty').attr('data-vid');
    gred.updateP2(quantity, variant_id);

  })

}


/********************************************************
# Update price
********************************************************/
gred.updateP = function() {
  $('.cart__qty .cart__qty-input').on('change', function() {
    var quantity = $(this).val();
    var variant_id = $(this).attr('data-vid');

    gred.doAjaxUpdateQty(variant_id, quantity);
    var new_val = $(this).val();
    if(new_val == 0){
      $(this).closest('.cart__row').fadeOut(300, function() { $(this).remove(); });
      $(this).closest('li.item').fadeOut(300, function() { $(this).remove(); });
    }

  });
}


gred.updateP2 = function(quantity, variant_id) {
  gred.doAjaxUpdateQty(variant_id, quantity);
}



/********************************************************
# CONVERTTOSLUG
********************************************************/
gred.convertToSlug = function (text) {
  return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
}

/********************************************************
# PRODUCT DETAIL - ADDTOCART
********************************************************/
gred.btnAddtocart = function () {
  $('.product-form__cart-submit').click(function(event) {
    var product_form = $(this).parents('form');

    if ($(this).attr('disabled') != 'disabled') {
      var variant_id = $('select[name=id]', product_form).val();
      if (!variant_id) {
        variant_id = $('input[name=id]', product_form).val();
      }
      var quantity = $('input[name=quantity]', product_form).val();
      if (!quantity) {
        quantity = 1;
      }
      var attributes = {};
      attributes['note'] = $("#ProductSelect-product-template option:selected").data("note") || "";
      attributes['note'] = $(`<div>${attributes['note']}</div>`).text();
      attributes['_refurbished'] = refurbished.toString();
      
      gred.doAjaxAddToCart(variant_id, quantity, attributes);
    }
    event.preventDefault();
    return false;
  });
}

gred.doAjaxAddToCart = function (variant_id, quantity, attributes) { 
  var data_string = "quantity=" + quantity + "&id=" + variant_id;
  $.each(attributes, function(i, attribute) {
    data_string += "&properties[" + i + "]=" + attribute;
  });
  var data = {};
  data['quantity'] = quantity;
  data['id'] = variant_id;
  data['properties'] = {}
  $.each(attributes, function(i, attribute) {
    data['properties'][i] = attribute;
  });

  $.ajax({
    type: "post",
    url: Shopify.routes.root + "cart/add.js",
    data: data, 
    dataType: 'json',
    beforeSend: function() {

    },
    success: function (msg) {
      if (window.kef.minicart.enable == false) {
        $(".error-message").text("");
        $(".Drawer--right").addClass("active");
        $(".offcanvas-cart").addClass("active");
        $(".backdrop").addClass("active");
        $("body").addClass("ov-h");
      }

      gred.updateMiniCart('add');
      minicart_v3.clearError();
      minicart_v3.open();

      $('body').trigger({
        type: 'add_to_cart',
        quantity: quantity,
        cart: msg,
      });
    },
    error: function (xhr, text) {
      if (window.kef.minicart.enable == false) {
        $(".error-message").text($.parseJSON(xhr.responseText).description);
        setTimeout(function () {
          $(".error-message").text("");
        }, 8000);
        $(".Drawer--right").addClass("active");
        $(".offcanvas-cart").addClass("active");
        $(".backdrop").addClass("active");
        $("body").addClass("ov-h");
      }

      minicart_v3.showError($.parseJSON(xhr.responseText).description);
      minicart_v3.open();
    },
  });
}

gred.doAjaxUpdateQty = function (variant_id, quantity) {
  $.ajax({
    type: "post",
    url: Shopify.routes.root + "cart/change.js",
    data: 'quantity='+quantity+'&id='+variant_id,
    dataType: 'json',
    beforeSend: function() {

    },
    success: function(msg) {
      gred.updateMiniCart();
      gred.updatePrice();
    },
    error: function(xhr, text) {
      $('.error-message').text($.parseJSON(xhr.responseText).description);

    }
  });
}

gred.updatePrice = function() {
  Shopify.getCart(function(cart) {
    gred.doUpdatePrice(cart);
  });
}

/* DO UPDATEPRICE */
gred.doUpdatePrice = function(cart) {
  for (var i = 0; i < cart.items.length; i++) {
    var t_price = cart.items[i].line_price;
    var v_id = cart.items[i].variant_id;
    $('.total-price.i-'+v_id).html(Shopify.formatMoney(cart.items[i].line_price, window.money_format));
    $('.total-price2.i-'+v_id).html(Shopify.formatMoney(cart.items[i].line_price, window.money_format));
  }

}

/********************************************************
# UPDATE MINICART
********************************************************/
gred.updateMiniCart = function(action) {
  action = action || '';
  $.ajax({
      type: 'GET',
      url: Shopify.routes.root + 'cart.js',
      cache: false,
      dataType: 'json',
      success: function(cart) {
        gred.doUpdateMiniCart(cart);
        minicart_v3.updateTitle(cart, action);
      }
  });
}

/* DO UPDATE MINICART */
gred.doUpdateMiniCart = function (cart) {
  // v3
  minicart_v3.update(cart);

  var total = Shopify.formatMoney(cart.total_price, window.money_format);
  var item_count = cart.item_count;
  $(".cart__subtotal #bk-cart-subtotal-price").html(total);
  $(".offcanvas-cart .total .cart-total").html(total);

  var total = total.replace("$", "");
  $(".cartCount .cart-total > span").html(total);

  var cart_disclaimer = $(".offcanvas-cart .cart-disclaimer > div");
  cart_disclaimer.html("");
  cart_disclaimer.parent().hide();

  var cart_disclaimer_txt = [];
  if (cart.item_count > 0) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties != null && cart.items[i].properties.hasOwnProperty('note') && cart.items[i].properties.note != '') {
        cart_disclaimer_txt.push(cart.items[i].properties.note.replace('This product', cart.items[i].product_title));
      }
    }

    if (cart_disclaimer_txt.length > 0) {
      var cart_disclaimer_txt_full = `<p class="cart__product-disclaimer"><small>
          Hinweis <br>
          ${cart_disclaimer_txt.join('<br>')}
        </small></p>`;
      cart_disclaimer.html(cart_disclaimer_txt_full);
      cart_disclaimer.parent().show();
    }
  }

  $(".site-header__link.site-header__cart .site-header__cart-indicator").html(item_count);
  $('.header-icon-cart-total-items').html(item_count);
  if(item_count == 0){
    $('.offcanvas-cart .summary').addClass('hide');
  	$('.offcanvas-cart .c-title .count').html(`(<span>${item_count}</span> ${theme.strings.minicartItem})`); 
  }else if(item_count == 1){
    $('.offcanvas-cart .summary').removeClass('hide');
  	$('.offcanvas-cart .c-title .count').html(`(<span>${item_count}</span> ${theme.strings.minicartItem})`); 
  }else{
    $('.offcanvas-cart .summary').removeClass('hide');
  	$('.offcanvas-cart .c-title .count').html(`(<span>${item_count}</span> ${theme.strings.minicartItems})`); 
  } 

  var template =
    '<li class="item clearfix" id="cart-item-{id}"><a href="javascript:void(0)" title="" class="btn-remove">{close}</a><a href="{url}" class="product-image"><img src="{img}" alt=""></a><div class="product-details"><a class="product-name" href="{url}">{title}</a><div class="product-meta"><span>{meta}</span></div><div class="cart__qty clearfix"><span class="money hide">{price}</span><span class="x-qty xx-qtyminus hide" data-v="minus">-</span><div class="qty__box"><span class="label">Quantity:</span><span class="xx-qty" data-vid="{v_id}">{quantity}</span></div><span class="x-qty xx-qtyplus hide" data-v="plus">+</span><div class="total-price2 i-{v_id}">{price2}</div></div></div></li>';
  var total = Shopify.formatMoney(cart.total_price, window.money_format);
  var item_count = cart.item_count;

  var closeHTML = $(".x-offcanvas").html();

  $(".cartCount .cart-total > span").html(total);
  $(".site-header__link.site-header__cart .site-header__cart-indicator").html(
    item_count
  );
  if(item_count == 0){
    $('.offcanvas-cart .summary').addClass('hide');
  	$('.offcanvas-cart .c-title .count').html(`(<span>${item_count}</span> ${theme.strings.minicartItem})`); 
  }else if(item_count == 1){
    $('.offcanvas-cart .summary').removeClass('hide');
  	$('.offcanvas-cart .c-title .count').html(`(<span>${item_count}</span> ${theme.strings.minicartItem})`); 
  }else{
    $('.offcanvas-cart .summary').removeClass('hide');
  	$('.offcanvas-cart .c-title .count').html(`(<span>${item_count}</span> ${theme.strings.minicartItems})`); 
  } 

  $(".miniCart-list").html("");

  var cart_disclaimer = $(".offcanvas-cart .cart-disclaimer > div");
  cart_disclaimer.html("");
  cart_disclaimer.parent().hide();

  var cart_disclaimer_txt = [];

  if (item_count > 0) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = template;

      if ($.trim(cart.items[i].variant_title) != "") {
        item = item.replace("{meta}", cart.items[i].variant_title);
      } else {
        item = item.replace("{meta}", " ");
      }
      item = item.replace("{close}", closeHTML);
      item = item.replace("{id}", cart.items[i].id);
      item = item.replaceAll("{url}", cart.items[i].url);
      item = item.replace(
        "{img}",
        Shopify.resizeImage(cart.items[i].image, "85x")
      );
      item = item.replace("{title}", cart.items[i].product_title);
      item = item.replace(
        "{price}",
        Shopify.formatMoney(cart.items[i].price, window.money_format)
      );
      item = item.replace("{quantity}", cart.items[i].quantity);
      item = item.replace("{v_id}", cart.items[i].variant_id);
      item = item.replace(
        "{price2}",
        Shopify.formatMoney(cart.items[i].line_price, window.money_format)
      );

      $(".miniCart-list").append(item);

      if (
        cart.items[i].properties != null &&
        cart.items[i].properties.hasOwnProperty("note") &&
        cart.items[i].properties.note != ""
      ) {
        cart_disclaimer_txt.push(cart.items[i].properties.note.replace('This product', cart.items[i].product_title));
      }
    }

    if (cart_disclaimer_txt.length > 0) {
      var cart_disclaimer_txt_full = `<p class="cart__product-disclaimer"><small>
          Hinweis <br>
          ${cart_disclaimer_txt.join('<br>')}
        </small></p>`;
      cart_disclaimer.html(cart_disclaimer_txt_full);
      cart_disclaimer.parent().show();
    }

    gred.removeItemsInMiniCart();
    //     gred.updateP();
    //     gred.quantity();
  } else {
    $('.miniCart-list').html(`<li class="item clearfix">
      <div class="minicart-empty">
        <div class="minicart-empty-bag">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="26" viewBox="0 0 21 26">
            <path fill="#FFF" d="M20.43 4.17h-4.853C15.097 1.748 12.971 0 10.5 0S5.902 1.747 5.423 4.17H.57c-.316 0-.571.256-.571.572V24.6c0 .15.06.296.167.403.107.107.252.167.404.167h19.858c.152 0 .297-.06.404-.167.107-.107.167-.252.167-.403V4.74c0-.315-.255-.57-.57-.57zM10.5 1.142c1.84.003 3.444 1.249 3.904 3.03H6.596c.46-1.781 2.065-3.027 3.904-3.03zm9.359 22.889H1.14V5.312h4.182v2.355c0 .315.255.57.57.57.315 0 .57-.255.57-.57V5.312h8.073v2.355c0 .315.256.57.57.57.316 0 .571-.255.571-.57V5.312h4.182V24.03z"/>
          </svg>
          <span>0</span>
        </div>
        <div class="summary">    
          <div class="actions">
            <a class="go-to-cart" href="">ZUR HOMEPAGE</a> 
          </div>
        </div>
      </div>
    </li>`);
  }
};


jQuery(gred.init)
